import { GuideContainer } from "./styled";
import logo_primary_image from "../../../assets/logo_primary.png";
import person_icon from "../../../assets/icons/person.svg";
import pin_icon from "../../../assets/icons/pin.svg";
import {
  FontWhiteMedium,
  FontPrimaryMediumSubTitle,
  FontPrimaryMediumTitle,
} from "../../../utils/typografyApp";
import { useState, useRef, useEffect } from "react";
import ExitModal from "../Modals/ExitModal";

const Guide = ({ showInfo = true, page }) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const [showExit, setShowExitModal] = useState(false);

  // ref para o pop-up
  const popUpRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popUpRef.current && !popUpRef.current.contains(event.target)) {
        setShowPopUp(false);
      }
    }

    if (showPopUp) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopUp]);

  return (
    <GuideContainer showInfo={showInfo ? "true" : "false"} isAdm={!!page}>
      <img src={logo_primary_image} alt="Logo do TAU na cor azul" />
      <button onClick={() => setShowPopUp(true)}>
        <img src={person_icon} alt="Icone de perfil" />
      </button>

      {showInfo && (
        <div className="location">
          <img src={pin_icon} alt="Icone de localização" />
          <FontWhiteMedium>
            {page ? (
              <FontWhiteMedium>
                {page} | <FontWhiteMedium>ADM TAU</FontWhiteMedium>
              </FontWhiteMedium>
            ) : (
              <FontWhiteMedium>Porto de VV | VLI</FontWhiteMedium>
            )}
          </FontWhiteMedium>
        </div>
      )}

      {showPopUp && (
        <div className="pop-up" ref={popUpRef}>
          <span onClick={() => setShowExitModal(true)}>Sair</span>
        </div>
      )}

      {showExit && <ExitModal onClose={() => setShowExitModal(false)} />}
    </GuideContainer>
  );
};

export default Guide;
